var exports = {
  "Lw": "x127c5a35--b85411--overlay",
  "DH": "x127c5a35--b85411--overlay--map",
  "Qq": "x127c5a35--b85411--text",
};

module.exports = exports;
